import React, { useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import {
  FaTaxi,
  FaPlus,
  FaUser,
  FaCar,
  FaUserPlus,
  FaTimes,
  FaClipboard,
  FaHistory,
} from 'react-icons/fa'
import { FaWallet } from 'react-icons/fa'
import { SkyButton } from '../Buttons'
import { LiaSortAmountUpSolid } from 'react-icons/lia'
import { GET_FLEET_TRANSACTIONS } from '../../Services/cabapi/fleetggl'
import AddMoney from '../../Screens/Transaction/Popup/AddMoney'
import { useLazyQuery } from '@apollo/client'

const Sidebar = ({ isDrawerOpen, toggleDrawer }) => {
  const [getFleetTransactions, { data, loading, refetch }] = useLazyQuery(
    GET_FLEET_TRANSACTIONS
  )
  const [addMoney, setAddMoney] = useState(false)
  const routes = [
    { name: 'Live Booking', path: '/cab-booking-report' },
    { name: 'Manage Driver', path: '/manage-driver' },
    { name: 'Manage Cabs', path: '/manage-cabs' },
    { name: 'Transaction', path: '/transaction' },
    { name: 'Booking History', path: '/booking-history' },
    // { name: 'Booking History', path: '/booking-history' },
  ]
  const location = useLocation()
  const routeIcons = {
    '/cab-booking-report': <FaClipboard />,
    '/manage-cabs': <FaTaxi />,
    '/manage-cabs/add-cab': <FaCar />,
    '/manage-driver': <FaUser />,
    '/manage-driver/add-driver': <FaUserPlus />,
    '/transaction': <FaWallet />,
    '/booking-history': <FaHistory />,
  }

  return (
    <div>
      <div
        className={`fixed top-0 left-0 w-64 h-full border-r bg-white text-stone-500 transition-transform duration-300 transform ${
          isDrawerOpen ? 'translate-x-0' : '-translate-x-full'
        } lg:hidden z-20`}
      >
        <div className="flex justify-between items-center p-4 bg-blue-50">
          <span className="text-xl font-semibold">Menu</span>
          <button onClick={toggleDrawer} className="text-xl">
            <FaTimes />
          </button>
        </div>
        <ul className="space-y-4 p-4 text-start">
          {routes.map((route) => (
            <li
              key={route.path}
              className={`hover:text-gray-400 pl-2 p-4 ${
                location.pathname === route.path
                  ? 'bg-blue-100 p-4 rounded-sm border-r-4 text-blue-500'
                  : ''
              }`}
            >
              <Link
                to={route.path}
                className={`hover:text-gray-400 ${
                  location.pathname === route.path ? 'rounded-sm' : ''
                } flex items-center`} // Added flex for icons and text
                onClick={toggleDrawer} // Close drawer on navigation
              >
                <span
                  className={`mr-2 ${
                    location.pathname === route.path
                      ? 'text-blue-500'
                      : 'text-stone-500'
                  }`}
                >
                  {routeIcons[route.path]}
                </span>
                {route.name}
              </Link>
            </li>
          ))}
        </ul>
        <div className="space-y-4 px-4">
          <ul className="space-y-4">
            <button
              onClick={() => {
                setAddMoney(true)
              }}
              className={`w-full p-2 rounded-lg text-lg font-medium flex items-center hover:bg-blue-200`}
            >
              <span className={`mr-3`}>
                <LiaSortAmountUpSolid />
              </span>
              Add Money
            </button>
          </ul>
        </div>
      </div>
      <div
        className={`hidden lg:block fixed top-20 left-0 w-64 h-full border-r-2 text-start text-stone-500 z-10`}
      >
        <div className="space-y-4 p-4">
          <ul className="space-y-4">
            {routes.map((route) => (
              <li key={route.path}>
                <Link
                  to={route.path}
                  className={` p-2 pl-5 rounded-lg text-lg font-medium flex items-center ${
                    location.pathname === route.path
                      ? 'bg-blue-100 p-4 rounded-sm border-r-4 text-blue-500'
                      : 'hover:bg-blue-200'
                  }`}
                >
                  <span
                    className={`mr-3 ${
                      location.pathname === route.path
                        ? 'text-blue-500'
                        : 'text-stone-500'
                    }`}
                  >
                    {routeIcons[route.path]}
                  </span>{' '}
                  {/* Icon */}
                  {route.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div className="space-y-4 px-4">
          <ul className="space-y-4">
            <button
              onClick={() => {
                setAddMoney(true)
              }}
              className={`w-full p-2 pl-5 rounded-lg text-lg font-medium flex items-center hover:bg-blue-200`}
            >
              <span className={`mr-3`}>
                <LiaSortAmountUpSolid />
              </span>
              Add Money
            </button>
          </ul>
        </div>
      </div>
      {addMoney && <AddMoney onClose={setAddMoney} refetch={refetch} />}
    </div>
  )
}

export default Sidebar
